<div class='widget-list-item' [ngStyle]="{'height': instance.height}" loading-spin [isLoading]="!instance" [loadingSize]="'inline'">
    <!-- <div class="checkbox">
        <label tam-checkbox [(ngModel)]="instance.selected"><span>&nbsp;</span></label>
    </div> -->
    <div class="item-container">
        <div #container></div>
    </div>
    <!-- <div class="refresh-btn">
        <smart-icon name="refresh" size="24" (click)="refreshItem()" title="Inherit from parent folder"></smart-icon>
    </div> -->
    <div class="remove-btn" [ngClass]="{'disabled': !instance.deletable}" title="{{instance.undeletableTitle}}">
        <smart-icon name="trash" size="24" (click)="deleteComponent()" *ngIf="onDelete.observers.length>0"></smart-icon>
    </div>
</div>
